var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:(_vm.style),attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","height":"100%","version":"1.1","viewBox":_vm.svg.viewBox,"width":"100%"}},[_c('use',{attrs:{"xlink:href":"#aplayer-${type}"}}),_vm._v(" "),_c('path',{staticClass:"aplayer-fill",attrs:{"d":_vm.svg.d}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08224b98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loader.js!./src/components/aplayer/components/aplayer-icon.vue
// module id = QHge
// module chunks = 29